// -----------------------------------------------------------------------------
// 初期設定 - 画面遷移用ヘルパーコンポーネント
// -----------------------------------------------------------------------------
import {useNavigate, useLocation} from 'react-router-dom';

/** 画面遷移用の履歴操作オブジェクト */
export const history = {
  navigate: null,
  location: null,
};

/**
 * 履歴操作オブジェクト提供コンポーネント
 *
 * Reactコンポーネント外から履歴操作/画面遷移を行うためのコンポーネント。
 * 履歴操作オブジェクト history 提供し、navigate() 関数を実行可能にする。
 *
 * @param {Object} children 子コンポーネント
 * @return {JSX.Element} 履歴提供コンポーネント
 */
export const HistoryProvider = ({children}) => {
  history.navigate = useNavigate();
  history.location = useLocation();
  return children;
};
